export class ParamData {
  account_id: number;
  prev_owner_fio: string;
  prev_owner_iin: string;
  address: string;
  new_owner_fio: string;
  new_owner_iin: string;
  m_phone_number: string;
  h_phone_number: string;
  person_live_count: number;
  child_live_count: number;
  adults_live_count: number;
  email: string;
  m_phone_number2: string;
  m_phone_number3: string;
  m_phone_number4: string;
  email2: string;
  house_building_type: number;
  tariff_plan_id: string;

  constructor() {
    this.account_id = null as any;
    this.prev_owner_fio = null as any;
    this.prev_owner_iin = null as any;
    this.address = null as any;
    this.new_owner_fio = null as any;
    this.new_owner_iin = null as any;
    this.m_phone_number = null as any;
    this.h_phone_number = null as any;
    this.person_live_count = null as any;
    this.email = null as any;
    this.m_phone_number2 = null as any;
    this.m_phone_number3 = null as any;
    this.m_phone_number4 = null as any;
    this.email2 = null as any;
    this.house_building_type = null as any;
    this.child_live_count = null as any;
    this.adults_live_count = null as any;
    this.tariff_plan_id = null as any;
  }
}
